import React from 'react'
import LeifNixonImg from '../../images/speakers/Leif-Nixon.jpg'

const LeifNixon = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
            <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="team-wrapper">
					<h2>Leif Nixon</h2>
                    <div className="row">
                        <div className="col-md-6">
                            <img src={LeifNixonImg} className="img-responsive" alt="Leif Nixon" />
                            <ul className="social-icon">
                                <li><a href="https://twitter.com/leifnixon" target="_blank" className="fa fa-twitter wow fadeIn"></a></li>
                            </ul>
                        </div>
                        <div className="col-md-5">
                        <p>
                        Leif Nixon, founder and owner of Nixon Security, has more than 10 years experience from IT security in Linux-centric environments. He regularly coordinates response to complex, multi-national incidents, and has a wide network of contacts in industry, academia and law enforcement.
                        <br /><br />
                        A regular contributor to industrial and academic IT security conferences, he is well prepared to give presentations on a range of subjects.
                        </p>
                        </div>
                    </div>
                    <div className="row">
                        <h4>Talk: HORRORLARITY</h4>
                        <p>
                        Whether to laugh or to cry, or both at the same time? Working in IT security can lead to some very mixed emotions. <br />
                        We will revisit some of the speaker's favourite security vulnerabilities, to laugh, and maybe cry, together. We will cover things like the app-enabled toilet with crap security, the shockingly bad smart grid system, and the open source repository that was really, REALLY open.
                        </p>
                    </div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default LeifNixon


// WEBPACK FOOTER //
// ./src/pages/speakers/leif-nixon.js